import React from 'react';
import { compose, prop } from 'ramda';
import { Helmet } from 'react-helmet';

import connect from 'app/libs/connect';
import { isNotFoundRoute } from 'app/router/selectors';
import renderIf from 'app/enhancers/renderIf';

const UI = () => (
  <Helmet>
    <meta name="prerender-status-code" content="404" />
  </Helmet>
);

const NotFoundPrerenderMeta = compose(
  connect({ isNotFoundRoute }),
  renderIf(prop('isNotFoundRoute')),
)(UI);

export default NotFoundPrerenderMeta;
